import type { FeatureTree } from './gen-feature-tree';

export type SubmitConfirmClaimsContentAnnotation = {
    term_unique_id: string;
    properties: {
        type: string;
        attrs: Record<string, unknown>;
    };
};

export type SubmitConfirmClaimsContentFigure = {
    unique_id: string;
    image: {
        s3_key: string;
        properties: Record<string, unknown>;
    };
    /**
     * 附图标注图片(base64)
     */
    annotation_image_base64: string;
    abstract_figure?: boolean;
    annotations: SubmitConfirmClaimsContentAnnotation[];
};

export type SubmitConfirmClaimsContentTerm = {
    unique_id: string;
    number: string;
    name: string;
};

export interface SubmitConfirmClaimsContentRequest {
    /** 任务ID */
    task_id: string;

    /** 特征树 */
    feature_tree: FeatureTree;

    /** 附图 */
    figures: SubmitConfirmClaimsContentFigure[];

    /** 术语 */
    terms: SubmitConfirmClaimsContentTerm[];
}

export interface SubmitConfirmClaimsContentResponse {}

export const SubmitConfirmClaimsContentApi = Symbol.for('SubmitConfirmClaimsContentApi');

export interface SubmitConfirmClaimsContentApi {
    submitConfirmClaimsContent(data: SubmitConfirmClaimsContentRequest): Promise<SubmitConfirmClaimsContentResponse>;
}
